import { authRefresh } from '@/fsd/entities/auth/api/authRefresh';
import { saveTokens } from '@/fsd/entities/auth/lib/helpers/saveTokens';
import { routes } from '../../config/routes/routesConfig';
import { HttpMethod, RequestConfig } from '../types';

let isRefreshing = false;
let failedQueue: any = [];

const processQueue = (error: any, token: string | null = null) => {
  failedQueue.forEach((prom: any) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

export const handleUnauthorizedRequest = <T>(
  requestFn: (
    endpoint: string,
    method: HttpMethod,
    config: RequestConfig
  ) => Promise<T>,
  onUnauthorized: (() => Promise<void>) | undefined,
  endpoint: string,
  method: HttpMethod,
  config: RequestConfig,
  error: any
): Promise<T> => {
  const isLoginPage =
    window.location.pathname === routes.login.path ||
    window.location.pathname === routes.signup.path ||
    window.location.pathname === routes.yandexCallback.path ||
    window.location.pathname === routes.home.path;


  if (isLoginPage || endpoint.includes('/api/v1/auth/refresh/')) {

    onUnauthorized?.().finally(() => {
      window.location.href = routes.login.path;
    });
    return Promise.reject(error);
  }

  if (isRefreshing) {
    return new Promise((resolve, reject) => {
      failedQueue.push({ resolve, reject });
    }).then(() => requestFn(endpoint, method, config));
  }

  isRefreshing = true;

  return new Promise((resolve, reject) => {
    const refreshToken = localStorage.getItem('refresh_token');

    if (!refreshToken) {
      onUnauthorized?.();
      window.location.href = routes.login.path;
      isRefreshing = false;
      return reject(error);
    }


    authRefresh(refreshToken)
      .then((res) => {
        console.log('handleUnauthorizedRequest');
        saveTokens(res);
        processQueue(null, res.access);
        resolve(requestFn(endpoint, method, config));
      })
      .catch((err) => {
        onUnauthorized?.();
        window.location.href = routes.login.path;
        reject(err);
      })
      .finally(() => {
        isRefreshing = false;
      });
  });
};
